var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.7 13.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tag_filtro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.72,4.81l-.15.28a2.83,2.83,0,0,0-.13.5A3.3,3.3,0,0,0,.71,7c.28.88.56,1.77.85,2.65a12.82,12.82,0,0,0,1,2.62,2.23,2.23,0,0,0,.37.38l.49.25a3.33,3.33,0,0,0,1.94-.24l8-2.55a19.26,19.26,0,0,0,2.63-.91,1.9,1.9,0,0,0,.61-.62l.36-.7,0-.09c.28-.57.55-1.15.83-1.72.44-.93,1.36-2.14.44-3.07A35.9,35.9,0,0,0,14.88,1.1c-1.45-.83-1.44-.82-3-.33l-2.65.86L3.94,3.33a18.81,18.81,0,0,0-2.63.9,1.88,1.88,0,0,0-.59.6Z",
    transform: "translate(-0.16 -0.16)",
    fill: "none",
    stroke: "#131f30",
    strokeLinecap: "round",
    strokeMiterlimit: 13.12,
    strokeWidth: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.2,
    cy: 4.48,
    r: 1.1,
    fill: "#131f30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag_icon.7059fdb420c1ca1d202494484d3eeeb5.svg";
export { ForwardRef as ReactComponent };